import React from 'react';

import { cn } from '../../lib/utils';

const isPlainTitle = (title) => typeof title === 'string' || typeof title === 'number';

const ModalTopBarTitle = ({ children, className, ...props }) => {
  return (
    <div className={cn('truncate text-sm/5 font-semibold text-black dark:text-neutral-200', className)} {...props}>
      {children}
    </div>
  );
};

const ModalTopBar = ({ title, children, className, contentClassName, ...props }) => {
  const content = children ?? title;

  return (
    <div className={cn('flex min-h-9 items-center justify-center text-center', className)} {...props}>
      <div className={cn('flex min-w-0 max-w-full justify-center px-12', contentClassName)}>
        {isPlainTitle(content) ? <ModalTopBarTitle>{content}</ModalTopBarTitle> : content}
      </div>
    </div>
  );
};

export { ModalTopBar, ModalTopBarTitle };
